import { Field } from "./Field";
import { Button } from "./Button";

export const NO_FILTER = { type: "", from: "", to: "", text: "" };

/**
 * Narrow a history that is already on screen (#567): by kind of entry, by
 * date range, and by a word in it. Filtering happens in the browser on the
 * rows the page holds, then DataTable pages the result (#566), so the page
 * count always describes what is being looked at.
 *
 * `typeOf`, `dateOf` and `textOf` say where each value lives on a row, so
 * the same filter serves any history. Dates compare as YYYY-MM-DD text.
 */
export function applyHistoryFilter(rows, f, { typeOf, dateOf, textOf }) {
  const needle = f.text.trim().toLowerCase();
  return (rows || []).filter((r) => {
    if (f.type && typeOf(r) !== f.type) return false;
    const day = String(dateOf(r) || "").slice(0, 10);
    if (f.from && day < f.from) return false;
    if (f.to && day > f.to) return false;
    if (needle && !String(textOf(r) || "").toLowerCase().includes(needle)) return false;
    return true;
  });
}

export function HistoryFilters({ types, value, onChange, shown, total }) {
  const set = (key) => (e) => onChange({ ...value, [key]: e.target.value });
  const active = Object.values(value).some(Boolean);
  return (
    <div style={{ marginBottom: "var(--space-3)" }}>
      <div style={{ display: "flex", gap: "var(--space-3)", flexWrap: "wrap", alignItems: "flex-end" }}>
        <Field label="What">
          {(id, aria) => (
            <select id={id} {...aria} value={value.type} onChange={set("type")} className="touch-target">
              <option value="">Everything</option>
              {types.map((t) => <option key={t} value={t}>{t}</option>)}
            </select>
          )}
        </Field>
        <Field label="From">
          {(id, aria) => <input id={id} {...aria} type="date" value={value.from} onChange={set("from")} className="touch-target" />}
        </Field>
        <Field label="To">
          {(id, aria) => <input id={id} {...aria} type="date" value={value.to} onChange={set("to")} className="touch-target" />}
        </Field>
        <Field label="Search">
          {(id, aria) => <input id={id} {...aria} type="search" placeholder="Detail or note" value={value.text} onChange={set("text")} className="touch-target" />}
        </Field>
        {active && <Button variant="secondary" onClick={() => onChange(NO_FILTER)}>Clear filters</Button>}
      </div>
      {active && (
        <p style={{ color: "var(--color-text-muted)", fontSize: "var(--font-size-sm)", margin: "var(--space-2) 0 0" }}>
          Showing {shown} of {total} entries
        </p>
      )}
    </div>
  );
}
